module.exports = __webpack_public_path__ + "static/media/step1of3.fb6bd338.svg";